import { BreakpointPixelValue } from '@leland-dev/leland-ui-library';

export const CARD_CAROUSEL_BREAKPOINTS = {
  580: {
    spaceBetween: 12,
    slidesPerView: 2,
    slidesPerGroup: 2,
  },
  [BreakpointPixelValue.SM]: {
    spaceBetween: 20,
    slidesPerView: 2,
    slidesPerGroup: 2,
  },
  [BreakpointPixelValue.MD]: {
    spaceBetween: 16,
    slidesPerView: 3,
    slidesPerGroup: 3,
  },
  [BreakpointPixelValue.LG]: {
    spaceBetween: 16,
    slidesPerView: 4,
    slidesPerGroup: 4,
  },
  [BreakpointPixelValue.XL]: {
    spaceBetween: 20,
    slidesPerView: 4,
    slidesPerGroup: 4,
  },
  [BreakpointPixelValue['2XL']]: {
    spaceBetween: 20,
    slidesPerView: 5,
    slidesPerGroup: 5,
  },
} as const;
